import { Helmet } from 'react-helmet-async';

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

/**
 * BreadcrumbList Schema Component
 * Helps search engines and AI understand page navigation hierarchy
 */
const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({ items }) => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;

// Helper function to generate common breadcrumbs
export const generateBlogBreadcrumbs = (postTitle: string, postSlug: string): BreadcrumbItem[] => [
  { name: "Home", url: "https://www.schoolola.com.au" },
  { name: "Newsroom", url: "https://www.schoolola.com.au/newsroom" },
  { name: postTitle, url: `https://www.schoolola.com.au/newsroom/${postSlug}` }
];

export const generateProgramBreadcrumbs = (programName: string, programSlug: string): BreadcrumbItem[] => [
  { name: "Home", url: "https://www.schoolola.com.au" },
  { name: "Programs", url: "https://www.schoolola.com.au/programs" },
  { name: programName, url: `https://www.schoolola.com.au/programs/${programSlug}` }
];

export const generateCentreBreadcrumbs = (centreName: string, centreSlug: string): BreadcrumbItem[] => [
  { name: "Home", url: "https://www.schoolola.com.au" },
  { name: "Centres", url: "https://www.schoolola.com.au/centres" },
  { name: centreName, url: `https://www.schoolola.com.au/centres/${centreSlug}` }
];
